import React from 'react';
import { cx } from '../../utils/cx.js';

const TONES = {
  brand: 'bg-brand-600 dark:bg-brand-400',
  green: 'bg-[#16a866]',
  red: 'bg-red-500',
  gray: 'bg-gray-300 dark:bg-gray-600',
};

/** Thin progress track. `value` in [0, 100]; `indeterminate` animates when no count is known. */
const ProgressBar = ({ value = 0, tone = 'brand', indeterminate = false, label, className = '' }) => {
  const pct = Number.isFinite(value) ? Math.max(0, Math.min(100, Math.round(value))) : 0;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : pct}
      className={cx('h-1.5 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-white/5', className)}
    >
      <div
        className={cx('h-full rounded-full transition-[width] duration-500', TONES[tone] || TONES.brand, indeterminate && 'w-1/3 animate-pulse')}
        style={indeterminate ? undefined : { width: `${pct}%` }}
      />
    </div>
  );
};

export default ProgressBar;
